// Setup The Video Player so the First Video is loaded
export let loadTheVideo = () => {
  var firstVideoLink = $(".firstSingleBioliteTVCard").attr('data-video-link');
  $('.tvPlayButton').attr('data-video-active', firstVideoLink);
}

export let videoToggle = () => {

  let teal1 = '#008fa1';
  let teal2 = '#20a09d';
  let yellow1 = '#d9ab27';
  let yellow2 = '#ecb351';
  let orange = '#C24D00';
  let red = '#e73f34;';
  let purple = '#8e90b4';
  let gray1 = '#444444';
  let gray2 = '#2e2e2f';
  let gray3 = '#747475';
  let gray4 = '#a8a8a8';
  let gray5 = '#d7d7d7';
  let gray6 = '#e4e4e4';
  let gray7 = '#f3f3f3';
  let offwhite = '#f1f1f1';

  let swapImage = (theImageNumber) => {
    let tl = gsap.timeline({
      defaults:{
        duration:0.65,
        ease:'power4.out',
      }
    });
    let thisImage = $('[data-preview-image='+theImageNumber+']'); 
    let otherImages = $('.bioliteTvVideoPreviewImage').not(thisImage);
    // console.log(thisImage);
    tl.to(thisImage, {duration:0.65, opacity:1}, "imageSwap");
    tl.to(otherImages, {duration:0.65, opacity:0}, "imageSwap");
  }


  $('.single-biolite-tv-card').on('click',function(){

    let allTL = gsap.timeline({
      paused:true,
      defaults:{
        duration:0.65,
        ease:'power4.out',
        onComplete: function(){
          // Set the Paragrahs back to reanimte
          // gsap.set(allP, {y:30, opacity:0});
        }
      },
    });
    let topHeight = $(this).outerHeight() - 80;
    let allCard = $('.single-biolite-tv-card').not(this);
    let allP = allCard.find('p');
    let allTealIcon = allCard.find('.tvIconTeal');
    let allWhiteIcon = allCard.find('.tvIconWhite');
    let $this = $(this);
    let thisP = $(this).find('p');
    let tealIcon = $(this).find('.tvIconTeal');
    let whiteIcon = $(this).find('.tvIconWhite');
    let imageTrigger = $(this).attr('data-preview-image-trigger');
    let videoLink = $(this).attr('data-video-link');
    let playButton = $('.tvPlayButton');
    let previewImg = $('.bioliteTvVideoPreviewImageContainer');

    allTL.set(previewImg, {zIndex:2});
    allTL.set(thisP, {y:30, opacity:0});
    allTL.to(allCard, {color:gray1, background:"white", y:topHeight}, 'cardUp');
    allTL.to(allTealIcon, {opacity:1}, 'cardUp');
    allTL.to(allWhiteIcon, {opacity:0}, 'cardUp');
    // The Selected Card Animations    
    allTL.to($this, {color:"white", background:teal1, y:0}, 'cardUp');
    allTL.to(thisP, {y:0, opacity:1}, 'cardUp');
    allTL.to(tealIcon, {opacity:0}, 'cardUp');
    allTL.to(whiteIcon, {opacity:1}, 'cardUp');
    allTL.to(playButton, {scale:1}, 'cardUp');
    allTL.to(previewImg, {opacity:1}, 'cardUp');

    if ($(window).width() > 1024) {
      allTL.play();
      swapImage(imageTrigger);
    }
    $('.biolite-tv-video-frame iframe').remove();
    $('.tvPlayButton').attr('data-video-active', videoLink);
  });
  

  if ($(window).width() <= 1024) {
      
    $('.bioliteTvCardContainer').slick({
      infinite: true,
      slidesToShow: 1,
      asNavFor: ".bioliteTvVideoPreviewImageContainer",
      arrows:false,
      // prevArrow:'.sliderPrevNavArrow',
      // nextArrow:'.sliderNextNavArrow',
      speed:500,
      cssEase: 'cubic-bezier(.17,.67,.28,1)',
      // autoplay: true,
      autoplaySpeed: 4000,
    });

    $('.bioliteTvVideoPreviewImageContainer').slick({
      infinite: true,
      slidesToShow: 1,
      asNavFor: ".bioliteTvCardContainer",
      arrows:false,
      speed:500,
      cssEase: 'cubic-bezier(.17,.67,.28,1)',
    });

    $('.single-biolite-tv-card').on('click', function(){
      let thisKey = $(this).attr('data-video-link');
      let previewImg = $('.bioliteTvVideoPreviewImageContainer');
      let previewCards = $('.bioliteTvCardContainer');
      let bioliteTvCardContainerBack = $('.bioliteTvCardContainerBack');
      let playButton = $('.tvPlayButton');

      let clearOutTL = gsap.timeline({
        paused:true,
        duration:0.3,
        ease:"circ.out",
        onComplete: function(){
          gsap.set(previewImg, {zIndex:-1})
          // gsap.killTweensOf(playButton);
          // gsap.set(playButton, {rotate:0});
        }
      });

      let backInTL = gsap.timeline({
        paused:true,
        duration:0.3,
        ease:"circ.out",
        onComplete: function(){
          $('.biolite-tv-video-frame iframe').remove();
        }
      });

      clearOutTL.to(playButton, {scale:0}, 'playit');
      clearOutTL.to(previewImg, {opacity:0, zIndex:-1}, 'playit');
      clearOutTL.to(previewCards, {opacity:0,zIndex:-1}, 'playit');
      clearOutTL.to(bioliteTvCardContainerBack, {opacity:0, zIndex:-1},'playit');
      
      
      backInTL.to(previewImg, {opacity:1, zIndex:14}, 'playit2');
      backInTL.to(previewCards, {opacity:1, zIndex:14},'playit2');
      backInTL.to(bioliteTvCardContainerBack, {opacity:1, zIndex:12},'playit2');
      backInTL.to(playButton, {scale:1, zIndex:14}, 'playit2+=0.3');
      
    
      $('.biolite-tv-video-frame iframe').remove();
      $('.biolite-tv-video-frame').prepend("<div id='"+thisKey+"'></div>");
      
      $(".bioliteTvVideoPreviewImageContainer").slick('slickPause');
      $(".bioliteTvCardContainer").slick('slickPause');

      clearOutTL.play();
  
      function callYoutube(videoKey) {
        // LOAD THE NEW, SELECTED YOUTUBE VIDEO / PLAYER VIA YOUTUBE API
        player = new YT.Player(thisKey, {
          height: '100%',
          width: '100%',
          playerVars: {
            rel:0,
            autoplay: 1,
            controls: 0,
            showinfo: 0,
            autohide: 1,
            modestbranding: 1,
          },
          videoId: thisKey,
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });
  
        // HIDE OR SHOW OTHER VIDEOS DEPENDING ON YOTUBE PLAYER STATE
        function onPlayerStateChange(event) {
                  
          if (event.data == YT.PlayerState.BUFFERING) {
            // $(".bioliteTvVideoPreviewImageContainer").slick('slickPause');
            // $(".bioliteTvCardContainer").slick('slickPause');
            // clearOutTL.play();
          } else if (event.data == YT.PlayerState.PLAYING) {
            // IF PLAYING
            $(".bioliteTvVideoPreviewImageContainer").slick('slickPlay');
            $(".bioliteTvCardContainer").slick('slickPlay');
            clearOutTL.play();
          } else if (event.data == YT.PlayerState.PAUSED) {
            // IF PAUSED
            $(".bioliteTvVideoPreviewImageContainer").slick('slickPlay');
            $(".bioliteTvCardContainer").slick('slickPlay');
            backInTL.play();
          } else if (event.data == YT.PlayerState.ENDED) {
            // IF FINISHED
            $(".bioliteTvVideoPreviewImageContainer").slick('slickPlay');
            $(".bioliteTvCardContainer").slick('slickPlay');
            backInTL.play();
           
          }
        } //STATE CHANGE
      } //callYoutube()
  
      // if ($(window).width() > 1024) {
  
        callYoutube();
    });
  }
  else {
  
    $('.tvPlayButton').on('click', function(){
      let thisKey = $(this).attr('data-video-active');
      let playButton = $('.tvPlayButton');

      gsap.to(playButton, {rotate:360, duration:0.75, repeat:-1, ease:'none'});
    
      $('.biolite-tv-video-frame iframe').remove();
      $('.biolite-tv-video-frame').prepend("<div id='"+thisKey+"'></div>");


      function callYoutube(videoKey) {
        // LOAD THE NEW, SELECTED YOUTUBE VIDEO / PLAYER VIA YOUTUBE API
        player = new YT.Player(thisKey, {
          height: '100%',
          width: '100%',
          playerVars: {
            rel:0,
            autoplay: 1,
            controls: 0,
            showinfo: 0,
            autohide: 1,
            modestbranding: 1,
          },
          videoId: thisKey,
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });

        // HIDE OR SHOW OTHER VIDEOS DEPENDING ON YOTUBE PLAYER STATE
        function onPlayerStateChange(event) {
          
          let previewImg = $('.bioliteTvVideoPreviewImageContainer');
          let previewCards = $('.bioliteTvCardContainer');
          let bioliteTvCardContainerBack = $('.bioliteTvCardContainerBack');
          
          let tl = gsap.timeline({
            paused:true,
            duration:0.3,
            ease:"circ.out",
            onComplete: function(){
              gsap.set(previewImg, {zIndex:-1})
              gsap.killTweensOf(playButton);
              gsap.set(playButton, {rotate:0});
            }
          });

          let tl2 = gsap.timeline({
            paused:true,
            duration:0.3,
            ease:"circ.out",
            onComplete: function(){
              // gsap.set(previewImg, {zIndex:9})
            }
          });
          
          tl.to(playButton, {scale:0}, 'playit');
          tl.to(previewImg, {opacity:0}, 'playit');
          tl.to(previewCards, {y:'100%'}, 'playit');
          tl.to(bioliteTvCardContainerBack, {opacity:0},'playit');
          
          tl2.to(previewCards, {y:'0%'},'playit2');
          tl2.to(bioliteTvCardContainerBack, {opacity:1},'playit2');
    

          if (event.data == YT.PlayerState.BUFFERING) {
            // IF BUFFERING   
            // curtainsDown();
            tl.play();
          } else if (event.data == YT.PlayerState.PLAYING) {
            // IF PLAYING
            tl.play();
            // curtainsDown();
          } else if (event.data == YT.PlayerState.PAUSED) {
            // IF PAUSED
            tl2.play();
            // curtainsUp();
          } else if (event.data == YT.PlayerState.ENDED) {
            // IF FINISHED
            tl2.play();
            // curtainsUp();
          }    
        } //STATE CHANGE
      } //callYoutube()

      // if ($(window).width() > 1024) {

        callYoutube();
    });
  } //End 1024 Media Query
  
}